import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function VerifyPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (!token) {
      navigate('/firm');
      return;
    }

    // 1) Call the backend to verify
    fetch(`https://cloud9requests.symphony.com/requests/api/verify?token=${token}`, {
      credentials: 'include'
    })
      .then(res => res.json())
      .then(data => {
        if (data.email) {
          // success
          navigate('/accountsPage', {
            state: { email: data.email }
          });
        } else {
          alert(data.message || 'Invalid or expired token');
          navigate('/firm');
        }
      })
      .catch(err => {
        console.error(err);
        alert('Verification error');
        navigate('/firm');
      });
  }, [navigate]);

  return (
    <div>Verifying your email, please wait...</div>
  );
}

export default VerifyPage;
